import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";

interface AlertDisplaySlice
{
    opacity: number;
    shouldDisplay: boolean;
    isFetchingData: boolean;
    lastReportedUpdateTime: number;
    alertFetchProgress: number | undefined;
}

const initialAlertDisplayState: AlertDisplaySlice = {
    opacity: 0.6,
    shouldDisplay: false,
    isFetchingData: false,
    lastReportedUpdateTime: Date.now(),
    alertFetchProgress: undefined,
};

export const alertDisplaySlice = createSlice( {
    name: "alertDisplay",
    initialState: initialAlertDisplayState,
    reducers: {
        showAlerts( state )
        {
            state.shouldDisplay = true;
        },
        hideAlerts( state )
        {
            state.shouldDisplay = false;
        },
        setAlertOpacity( state, action: PayloadAction<number> )
        {
            state.opacity = action.payload;
        },
        setIsFetchingAlertData( state )
        {
            state.isFetchingData = true;
            state.alertFetchProgress = 0;
        },
        setIsNotFetchingAlertData( state )
        {
            state.isFetchingData = false;
            state.alertFetchProgress = undefined;
        },
        setLatestUpdate( state, action: PayloadAction<number> )
        {
            state.lastReportedUpdateTime = action.payload;
        },
        setAlertFetchProgress( state, action: PayloadAction<number> )
        {
            state.alertFetchProgress = action.payload;
        }
    }
} );

const selectShouldShowAlerts = ( state: RootState ) => state.alertDisplay.shouldDisplay;
const selectAlertOpacity = ( state: RootState ) => state.alertDisplay.opacity;
const isFetchingAlertData = ( state: RootState ) => state.alertDisplay.isFetchingData;
const lastReportedAlertUpdateTime = ( state: RootState ) => state.alertDisplay.lastReportedUpdateTime;
const alertFetchProgress = ( state: RootState ) => state.alertDisplay.alertFetchProgress;

export const useShouldShowAlerts = () => useAppSelector( selectShouldShowAlerts );
export const useAlertOpacity = () => useAppSelector( selectAlertOpacity );
export const useIsFetchingAlertData = () => useAppSelector( isFetchingAlertData );
export const useLastReportedAlertUpdateTime = () => useAppSelector( lastReportedAlertUpdateTime );
export const useAlertFetchProgress = () => useAppSelector( alertFetchProgress );

export const { showAlerts, hideAlerts, setAlertOpacity, setIsFetchingAlertData, setIsNotFetchingAlertData, setLatestUpdate, setAlertFetchProgress } = alertDisplaySlice.actions;

export default alertDisplaySlice.reducer;
